import { DateTime } from "luxon";

import { get } from "@readai/common/api";
import {
  BaseAggregateCoachingData,
  CoachingApiResponse,
} from "@readai/common/types";
import { DateRange } from "@readai/common/types";

import * as CoachingParser from "./parsers/coaching";

// ISO dates need to be encoded due to the `+` character
// that's present in the timezone offset
const formatAndEncodeDate = (date: DateTime) => {
  const dateString = date.toISO();
  return dateString ? encodeURIComponent(dateString) : null;
};

export const getCoachingData = async (
  dateRange: DateRange,
): Promise<BaseAggregateCoachingData> => {
  const json: CoachingApiResponse = await get(
    `/metrics/coaching?start_date=${formatAndEncodeDate(
      dateRange.startDate,
    )}&end_date=${formatAndEncodeDate(dateRange.endDate)}`,
    { withCreds: true },
  );

  return CoachingParser.parseCoachingResponse(json);
};
